import { post, get } from '@/api/general';

export default {
    delete: (body) => post('account/delete', body),
    confirm: (body) => post('account/confirm', body),
    balance: () => get('account/balance'),
};
